window.addEventListener('DOMContentLoaded', function() {
    let path = window.location.pathname;
    if(path.includes('tagged')) {
        const pathSplit = path.split('/');
        const tagVal = pathSplit.pop();
        const tagChecked = document.querySelector(`#${tagVal}`);
        if(tagChecked) {
            tagChecked.checked = true;
        }
        path = path.split('/').slice(0, 3).join('/');
    }
    else {
        const tagChecked = document.querySelector('input[name="blog-tags"][value=""]');
        if(tagChecked) {
            tagChecked.checked = true;
        }
    }
    const blogApplyBtn = document.querySelector('.blog-apply-btn');
    if (blogApplyBtn) {
        blogApplyBtn.addEventListener('click', function() {
            const tagChecked = document.querySelector('input[name="blog-tags"]:checked');
            if(tagChecked) {
                const tagVal = slugify(tagChecked.value);
                window.location.href = path + `${tagVal ? `/tagged/${tagVal}` : ''}`;
            }
        });
    }
    const facetDrawerBtn = document.querySelector('.facet-drawer-button');
    if(facetDrawerBtn) {
        const tagCheckedInit = document.querySelector('input[name="blog-tags"]:checked');
        facetDrawerBtn.addEventListener('click', function() {
            tagCheckedInit.checked = true;
        });
    }
});

function slugify(str) {
    return str
        .normalize("NFD")                    
        .replace(/[\u0300-\u036f]/g, "")     
        .toLowerCase()
        .trim()
        .replace(/\s+/g, '-')               
        .replace(/[^a-z0-9\-]/g, '')    
}